module.exports = __webpack_public_path__ + "img/d87a92f.png";